import { filterUndefined } from '../../../../../../utils/FilterUndefinedObject';
import './FfImageList.scss';

const defaultProps = {
  imageList: [],
};

const FfImageList = (p) => {
  const { imageList } = { ...defaultProps, ...filterUndefined({ ...p }) };
  return (
    <div className={`image-list ${imageList.length === 1 ? 'one-image' : 'multiple-images'}`}>
      {imageList.map((image, index) => (
        <div
          key={`ffImage-${index}`}
          data-test={`ffImage-${index}`}
          className='image-container'
          style={{ backgroundImage: `url(${image})` }}
        />
      ))}
    </div>
  );
};

export default FfImageList;
